import { SelectMenuItem } from 'bold-ui'
import { SelectDownshiftMenuProps } from 'bold-ui/lib/components/Select/SelectSingle/SelectDownshiftMenu'
import { CustomSelectFieldProps, SelectField } from 'components/form'
import { RenderGrupoSelectHeader } from 'components/form/field/select/RenderGrupoSelectHeader'
import { ErrataNotaComplementarJustificativaEnum } from 'graphql/types.generated'
import { Fragment } from 'react'

import {
  justificativaErrataNotaComplementarRecord,
  justificativasPorTipoErrataNotaComplementarRecord,
  TipoErrataNotaComplementarEnum,
  tipoErrataNotaComplementarRecord,
} from '../model-errataNotaComplementar'

type JustificativaErrataNotaComplementarSelectFieldProps = CustomSelectFieldProps<
  ErrataNotaComplementarJustificativaEnum
>

const tipos = Object.values(TipoErrataNotaComplementarEnum)

const items = tipos.flatMap((tipo) => justificativasPorTipoErrataNotaComplementarRecord[tipo])

const tipoPorJustificativaRecord = tipos.reduce<
  Partial<Record<ErrataNotaComplementarJustificativaEnum, TipoErrataNotaComplementarEnum>>
>((acc, tipo) => {
  justificativasPorTipoErrataNotaComplementarRecord[tipo].forEach((justificativa) => (acc[justificativa] = tipo))
  return acc
}, {})

function JustificativaItem(
  itemProps: SelectDownshiftMenuProps<ErrataNotaComplementarJustificativaEnum> & {
    item: ErrataNotaComplementarJustificativaEnum
    index: number
  }
) {
  const {
    item,
    index,
    downshift: { getItemProps, highlightedIndex },
  } = itemProps

  const tipo = tipoPorJustificativaRecord[item]
  const isPrimeiraJustificativaDoTipo = justificativasPorTipoErrataNotaComplementarRecord[tipo][0] === item

  return (
    <Fragment>
      {isPrimeiraJustificativaDoTipo && (
        <RenderGrupoSelectHeader titulo={tipoErrataNotaComplementarRecord[tipo]} itemProps={{}} />
      )}
      <SelectMenuItem selected={highlightedIndex === index} {...getItemProps({ item })}>
        {itemToString(item)}
      </SelectMenuItem>
    </Fragment>
  )
}

const components = { Item: JustificativaItem }

export function JustificativaErrataNotaComplementarSelectField(
  props: Readonly<JustificativaErrataNotaComplementarSelectFieldProps>
) {
  return (
    <SelectField<ErrataNotaComplementarJustificativaEnum>
      items={items}
      itemToString={itemToString}
      components={components}
      {...props}
    />
  )
}

const itemToString = (item: ErrataNotaComplementarJustificativaEnum) =>
  item && justificativaErrataNotaComplementarRecord[item]
